<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getBannerTable(1)">
          <input-search :model="search" @update="searchInput" />
        </div>
        <circle-button
          v-if="
            permissionBanner &&
              permissionBanner.permission_id === permission.readWrite
          "
          @click.native="createBannerData"
        />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in headers"
                :key="header.id"
              >
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon
                      class="fas fa-caret-down"
                      v-if="sort_date == 'desc'"
                      style="font-size: 12px"
                    ></v-icon>
                    <v-icon
                      class="fas fa-caret-up"
                      v-if="sort_date == 'asc'"
                      style="font-size: 12px"
                    ></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataTable" :key="data.id">
              <td>{{ (dataPaginate.current_page - 1) * 10 + (index + 1) }}</td>
              <td>{{ data.title }}</td>
              <td>{{ data.status }}</td>
              <td>{{ data.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showBannerData(data.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate
      :length="dataPaginate.last_page"
      :page="dataPaginate.current_page"
      @update="changePage"
    >
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../components/Icon/icon-pencil";
import CircleButton from "../../components/Button/CircleButton";
import InputSearch from "../../components/Input/InputSearch";
import Paginate from "../../components/Layout/Paginate";
import { permissionBanner, role } from "../../util/Permission";
import Swal from "sweetalert";
import Loading from "vue-loading-overlay";

export default {
  name: "BannerTable",
  components: { Paginate, InputSearch, CircleButton, IconPencil, Loading },
  computed: {
    permissionBanner
  },
  data() {
    return {
      title: "Banner",
      isLoading: false,
      headers: [
        { id: 1, text: "No.", icon: null },
        { id: 2, text: "Title", icon: null },
        { id: 33, text: "Status", icon: null },
        { id: 22, text: "Update date", icon: true },
        { id: 5, text: "Edit", icon: null }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      permission: null,
      search: "",
      sort_active: "desc",
      sort_date: "desc"
    };
  },
  created() {
    this.permission = role;
    this.getBannerTable(1);
  },
  methods: {
    getBannerTable(page) {
      this.isLoading = true;
      this.$store
        .dispatch("Banner/getBanner", {
          page,
          search: this.search,
          sort_date: this.sort_date
        })
        .then(res => {
          console.log("res", res);
          if (res.response_code == 200) {
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            };
          } else {
            Swal(res.response_msg);
          }
          this.isLoading = false;
        })
        .catch(() => {
          Swal("", "Cannot get Banner data", "error");
          this.isLoading = false;
        });
    },
    async changePage(val) {
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getBannerTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    goToBannerEdit() {
      this.$router.push("/banner/edit");
    },
    showBannerData(id) {
      this.isLoading = true;
      this.$store
        .dispatch("Banner/showBanner", id)
        .then(res => {
          console.log("res123", res.result.banner);
          if (res.response_code == 200) {
            this.$store
              .dispatch("Banner/setFormBanner", res.result)
              .then(() => {
                this.goToBannerEdit();
              });
          }
          this.isLoading = false;
        })
        .catch(() => {
          Swal("", "Cannot get Banner data", "error");
          this.isLoading = false;
        });
    },
    createBannerData() {
      this.$store.dispatch("Banner/clearFormData").then(() => {
        this.goToBannerEdit();
      });
    },
    searchInput(val) {
      this.search = val;
    },
    sortDataTable(header_id) {
      if (header_id === 22) {
        //sort by updated_at
        this.sort_date = this.sort_date == "desc" ? "asc" : "desc";
      }
      this.getBannerTable(1);
    }
  }
};
</script>

<style scoped>
.branch-data {
  background-color: transparent;
  margin: 20px;
}
</style>
